import { IconProps as ChakraIconProps } from '@chakra-ui/react';
import { ArrowBackIcon } from './icons/arrow-back';
import { ArrowDownIcon } from './icons/arrow-down';
import { ArrowForwardIcon } from './icons/arrow-forward';
import { ArrowLeftIcon } from './icons/arrow-left';
import { ArrowOutward } from './icons/arrow-outward';
import { ArrowRightIcon } from './icons/arrow-right';
import { ArrowRightFull } from './icons/arrow-right-full';
import { ArrowUpIcon } from './icons/arrow-up';
import { AutoRenewIcon } from './icons/auto-renew';
import { BasketIcon } from './icons/basket';
import { CalendarIcon } from './icons/calendar';
import { CalendarRangeIcon } from './icons/calendar-range';
import { CashPaymentIcon } from './icons/cash-payment';
import { CashWithdrawalIcon } from './icons/cash-withdrawal';
import { CheckIcon } from './icons/check';
import { CheckListIcon } from './icons/checklist';
import { CircleEllipsis } from './icons/circle-ellipsis';
import { CloseIcon } from './icons/close';
import { DoubleArrowLeftIcon } from './icons/double-arrow-left';
import { DoubleArrowRightIcon } from './icons/double-arrow-right';
import { DrawIcon } from './icons/draw';
import { Edit } from './icons/edit';
import { EmployeesIcon } from './icons/employees';
import { Error } from './icons/error';
import { EuroIcon } from './icons/euro';
import { EventAvailableIcon } from './icons/event-available';
import { ExternalLinkIcon } from './icons/external-link';
import { FileCopyIcon } from './icons/file-copy';
import { FileDownloadIcon } from './icons/file-download';
import { FileUploadedIcon } from './icons/file-uploaded';
import { ForwardToIcon } from './icons/forward-to';
import { GearIcon } from './icons/gear';
import { GiftCardIcon } from './icons/gift-card';
import { GridIcon } from './icons/grid';
import { HamburgerMenuIcon } from './icons/hamburger-menu';
import { HealthIcon } from './icons/health';
import { HomeIcon } from './icons/home';
import { HomeWorkIcon } from './icons/home-work';
import { HorizontalDotsMenu } from './icons/horizontal-dots-menu';
import { ImportIcon } from './icons/import';
import { InfoIcon } from './icons/info';
import { InsertDocumentIcon } from './icons/insert-document';
import { InviteIcon } from './icons/invite';
import { Laptop } from './icons/laptop';
import { LinkIcon } from './icons/link';
import { LocalOfferIcon } from './icons/local-offer';
import { MoneyIcon } from './icons/money';
import { OpenInNewIcon } from './icons/open-in-new';
import { PaymentCardIcon } from './icons/payment-card';
import { PenIcon } from './icons/pen';
import { PlusIcon } from './icons/plus';
import { PuzzlePieceIcon } from './icons/puzzle-piece';
import { QrCodeIcon } from './icons/qr-code';
import { SearchIcon } from './icons/search';
import { SignOutIcon } from './icons/sign-out';
import { Smartphone } from './icons/smartphone';
import { SparksIcon } from './icons/sparks';
import { SuccessIcon } from './icons/success';
import { Sync } from './icons/sync';
import { SyncDisabled } from './icons/sync-disabled';
import { Tablet } from './icons/tablet';
import { TaskSuccessIcon } from './icons/task-success';
import { ToggleOffIcon } from './icons/toggle-off';
import { TrashIcon } from './icons/trash';
import { TravelIcon } from './icons/travel';
import { UndoArrowIcon } from './icons/undo-arrow';
import { FileUploadIcon } from './icons/upload';
import { VerticalDotsMenuIcon } from './icons/vertical-dots-menu';
import { WalletIcon } from './icons/wallet';
import { WarningIcon } from './icons/warning';
import { WarningOutlinedIcon } from './icons/warning-outlined';
import { WarningRoundIcon } from './icons/warning-round';

export enum IconName {
  ArrowBack = 'arrow-back',
  ArrowDown = 'arrow-down',
  ArrowForward = 'arrow-forward',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowRightFull = 'arraow-right-full',
  ArrowOutward = 'arrow-outward',
  ArrowUp = 'arrow-up',
  AutoRenew = 'auto-renew',
  Basket = 'basket',
  Calendar = 'calendar',
  CalendarRange = 'calendar-range',
  CashPayment = 'cash-payment',
  CashWithdrawal = 'cash-withdrawal',
  Check = 'check',
  CheckList = 'checklist',
  CircleEllipsis = 'circle-ellipsis',
  Close = 'close',
  DoubleArrowLeft = 'double-arrow-left',
  DoubleArrowRight = 'double-arrow-right',
  Draw = 'draw',
  Edit = 'edit',
  Employees = 'employees',
  Euro = 'euro',
  Error = 'error',
  EventAvailable = 'event-available',
  ExternalLink = 'external-link',
  FileDownload = 'file-download',
  FileUploadIcon = 'file-upload',
  FileUploadedIcon = 'file-uploaded',
  Gear = 'gear',
  GiftCard = 'gift-card',
  Grid = 'grid',
  HamburgerMenu = 'hamburger-menu',
  Home = 'home',
  HomeWork = 'home-work',
  HorizontalDotsMenu = 'horizontal-dots-menu',
  VerticalDotsMenu = 'vertical-dots-menu',
  Import = 'import',
  Info = 'info',
  Invite = 'invite',
  Laptop = 'laptop',
  Link = 'link',
  LocalOffer = 'local-offer',
  Pen = 'pen',
  Plus = 'plus',
  PuzzlePiece = 'puzzle-piece',
  Search = 'search',
  SignOut = 'sign-out',
  Smartphone = 'smartphone',
  Success = 'success',
  Sync = 'sync',
  SyncDisabled = 'sync-disabled',
  Tablet = 'tablet',
  Trash = 'trash',
  Travel = 'travel',
  Warning = 'warning',
  PaymentCard = 'payment-card',
  ToggleOff = 'toggle-off',
  Money = 'money-icon',
  QRCode = 'qr-code',
  Health = 'health',
  InsertDocument = 'insert-document',
  FileCopy = 'file-copy',
  Sparks = 'sparks',
  ForwardTo = 'forward-to',
  TaskSuccess = 'task-success',
  WarningOutlined = 'warning-outlined',
  UndoArrow = 'undo-arrow',
  Wallet = 'wallet',
  WarningRound = 'warning-round',
  OpenInNew = 'open-in-new'
}

export type IconProps = ChakraIconProps & {
  name: IconName;
};

export function Icon({ name, ...props }: IconProps): JSX.Element | null {
  const iconProps = { ...props, role: 'presentation' };

  switch (name) {
    case 'circle-ellipsis':
      return <CircleEllipsis {...iconProps} />;
    case 'horizontal-dots-menu':
      return <HorizontalDotsMenu {...iconProps} />;
    case 'vertical-dots-menu':
      return <VerticalDotsMenuIcon {...iconProps} />;
    case 'link':
      return <LinkIcon {...iconProps} />;
    case 'draw':
      return <DrawIcon {...iconProps} />;
    case 'euro':
      return <EuroIcon {...iconProps} />;
    case 'arrow-right':
      return <ArrowRightIcon {...iconProps} />;
    case 'arrow-up':
      return <ArrowUpIcon {...iconProps} />;
    case 'arrow-down':
      return <ArrowDownIcon {...iconProps} />;
    case 'arrow-back':
      return <ArrowBackIcon {...iconProps} />;
    case 'arrow-outward':
      return <ArrowOutward {...iconProps} />;
    case 'event-available':
      return <EventAvailableIcon {...iconProps} />;
    case 'external-link':
      return <ExternalLinkIcon {...iconProps} />;
    case 'error':
      return <Error {...iconProps} />;
    case 'local-offer':
      return <LocalOfferIcon {...iconProps} />;
    case 'travel':
      return <TravelIcon {...iconProps} />;
    case 'gift-card':
      return <GiftCardIcon {...iconProps} />;
    case 'info':
      return <InfoIcon {...iconProps} />;
    case 'home':
      return <HomeIcon {...iconProps} />;
    case 'grid':
      return <GridIcon {...iconProps} />;
    case 'basket':
      return <BasketIcon {...iconProps} />;
    case 'close':
      return <CloseIcon {...iconProps} />;
    case 'success':
      return <SuccessIcon {...iconProps} />;
    case 'sign-out':
      return <SignOutIcon {...iconProps} />;
    case 'arrow-forward':
      return <ArrowForwardIcon {...iconProps} />;
    case 'warning':
      return <WarningIcon {...iconProps} />;
    case 'double-arrow-left':
      return <DoubleArrowLeftIcon {...iconProps} />;
    case 'double-arrow-right':
      return <DoubleArrowRightIcon {...iconProps} />;
    case 'hamburger-menu':
      return <HamburgerMenuIcon {...iconProps} />;
    case 'file-download':
      return <FileDownloadIcon {...iconProps} />;
    case 'file-upload':
      return <FileUploadIcon {...iconProps} />;
    case 'file-uploaded':
      return <FileUploadedIcon {...iconProps} />;
    case 'calendar':
      return <CalendarIcon {...iconProps} />;
    case 'trash':
      return <TrashIcon {...iconProps} />;
    case 'employees':
      return <EmployeesIcon {...iconProps} />;
    case 'cash-withdrawal':
      return <CashWithdrawalIcon {...iconProps} />;
    case 'cash-payment':
      return <CashPaymentIcon {...iconProps} />;
    case 'search':
      return <SearchIcon {...iconProps} />;
    case 'plus':
      return <PlusIcon {...iconProps} />;
    case 'arrow-left':
      return <ArrowLeftIcon {...iconProps} />;
    case 'pen':
      return <PenIcon {...iconProps} />;
    case 'puzzle-piece':
      return <PuzzlePieceIcon {...iconProps} />;
    case 'check':
      return <CheckIcon {...iconProps} />;
    case 'home-work':
      return <HomeWorkIcon {...iconProps} />;
    case 'checklist':
      return <CheckListIcon {...iconProps} />;
    case 'gear':
      return <GearIcon {...iconProps} />;
    case 'import':
      return <ImportIcon {...iconProps} />;
    case 'invite':
      return <InviteIcon {...iconProps} />;
    case 'sync':
      return <Sync {...iconProps} />;
    case 'sync-disabled':
      return <SyncDisabled {...iconProps} />;
    case 'payment-card':
      return <PaymentCardIcon {...iconProps} />;
    case 'toggle-off':
      return <ToggleOffIcon {...iconProps} />;
    case 'arraow-right-full':
      return <ArrowRightFull {...iconProps} />;
    case 'money-icon':
      return <MoneyIcon {...iconProps} />;
    case 'calendar-range':
      return <CalendarRangeIcon {...iconProps} />;
    case 'wallet':
      return <WalletIcon {...iconProps} />;
    case 'qr-code':
      return <QrCodeIcon {...iconProps} />;
    case 'warning-round':
      return <WarningRoundIcon {...iconProps} />;
    case 'health':
      return <HealthIcon {...iconProps} />;
    case 'insert-document':
      return <InsertDocumentIcon {...iconProps} />;
    case 'file-copy':
      return <FileCopyIcon {...iconProps} />;
    case 'sparks':
      return <SparksIcon {...iconProps} />;
    case 'auto-renew':
      return <AutoRenewIcon {...iconProps} />;
    case 'forward-to':
      return <ForwardToIcon {...iconProps} />;
    case 'task-success':
      return <TaskSuccessIcon {...iconProps} />;
    case 'warning-outlined':
      return <WarningOutlinedIcon {...iconProps} />;
    case 'undo-arrow':
      return <UndoArrowIcon {...iconProps} />;
    case 'smartphone':
      return <Smartphone {...iconProps} />;
    case 'tablet':
      return <Tablet {...iconProps} />;
    case 'laptop':
      return <Laptop {...iconProps} />;
    case 'edit':
      return <Edit {...iconProps} />;
    case 'open-in-new':
      return <OpenInNewIcon {...iconProps} />;
    default:
      return null;
  }
}
